import { getDBName } from '../config'
import { addDB, addCollection, addDocument, deleteDocumentBatch, deleteDocumentById, getDocumentById, getDocuments, updateDocumentBatch, updateDocumentById, getCollections, deleteFile, getDocumentSize, getFileBinary } from '../restHeart'
import { PageQuery } from '../interfaces/PageQuery'
import { KeyFilter } from '@/network/interfaces/KeyFilter'
import { SortQuery } from '@/network/interfaces/SortQuery'
import { FilterQuery } from '@/network/interfaces/FilterQuery'
import { uploadFile } from '@/network/restHeart/uploadFile'
import { getFileContent } from '@/network/restHeart/getFileContent'
import { aggregate } from '../restHeart/aggregate'
import { putCollectionObject } from '../restHeart/putObject'
import { updateCollection } from '../restHeart/updateCollection'
import { AxiosRequestConfig } from 'axios'

/**
 * 创建数据库
 */
export function createDB() {
	return addDB(getDBName(), { desc: '缺陷管理数据库' })
}

/**
 * 获取文档集合。
 * @param query
 */
export function queryCollection(query: PageQuery) {
	return getCollections(getDBName(), query)
}

/**
 * 创建文档集合。
 * @param collection 集合名称。
 * @param desc 描述信息。
 */
export function createCollection(collection: string, desc: any) {
	return addCollection(getDBName(), collection, desc)
}

/**
 * 更新文档。
 * @param collection 集合名称。
 * @param data 文档对象。
 */
export function uploadDocuments(collection: string, data: any) {
	return addDocument(getDBName(), collection, data)
}

/**
 * 删除文档。
 * @param collection 集合名称。
 * @param filter 删除条件。
 */
export function deleteDocuments(collection: string, filter: any) {
	return deleteDocumentBatch(getDBName(), collection, filter)
}

/**
 * 删除文档。
 * @param collection 集合名称。
 * @param id 文档Id。
 */
export function deleteDocument(collection: string, id: string) {
	return deleteDocumentById(getDBName(), collection, id)
}

/**
 * 查询文档。
 * @param collection 集合名称。
 * @param id 文档Id。
 */
export function queryDocumentById(collection: string, id: string) {
	return getDocumentById(getDBName(), collection, id)
}

/**
 * 查询文档。
 * @param collection 集合名称。
 * @param query 查询条件。
 */
export function queryDocuments<T>(collection: string, query: PageQuery) {
	return getDocuments<T>(getDBName(), collection, query)
}

/**
 * 上传文件。
 * @param collection
 * @param file
 * @param contentType
 * @param fileId
 * @param onProgress
 */
export function postFile(collection: string, file: Blob, contentType?: string, fileId?: string, onProgress = progressEvent => {}) {
	return uploadFile(getDBName(), collection, file, fileId, contentType, onProgress)
}

/**
 * 获取文件。
 * @param collection
 * @param fileId
 */
export function getFile(collection: string, fileId: string, requestConfig?: AxiosRequestConfig | undefined) {
	return getFileContent(getDBName(), collection, fileId, requestConfig)
}

/**
 * 删除文件。
 * @param collection
 * @param fileId
 */
export function deleteDocumentFile(collection: string, fileId: string) {
	return deleteFile(getDBName(), collection, fileId)
}

/**
 * 查询符合条件的全部数据。通过分页查询，遍历全部页码，获取全部数据。
 * @param collection 集合
 * @param sizePerRequest 每次查询的分页大小
 * @param filter 条件
 * @param keys key过滤
 * @param sort 排序规则
 */
export async function queryAll<T>(collection: string, sizePerRequest = 100, filter?: FilterQuery, keys?: KeyFilter, sort?: SortQuery) {
	const { data } = await queryDocuments<T>(collection, { pagesize: sizePerRequest, page: 1, filter, keys, sort })
	const { _total_pages, _embedded } = data
	if (_total_pages > 1) {
		let records: T[] = [..._embedded]
		for (let i = 2; i <= _total_pages; i++) {
			const { data } = await queryDocuments<T>(collection, { pagesize: sizePerRequest, page: i, filter, keys, sort })
			records = records.concat(data._embedded)
		}
		return records
	} else {
		return _embedded
	}
}

/**
 * 修改文档。
 * @param collection
 * @param filter
 * @param data
 */
export function modifyDocuments(collection: string, filter: any, data: any) {
	return updateDocumentBatch(getDBName(), collection, filter, data)
}

/**
 * 修改文档。
 * @param collection
 * @param id
 * @param data
 */
export function modifiyDocumentById(collection: string, id: string, data: any) {
	return updateDocumentById(getDBName(), collection, id, data)
}

/**
 * 修改文档。
 * @param collection
 * @param id
 * @param data
 */
export function modifyCollection(collection: string, data: any) {
	return updateCollection(getDBName(), collection, data)
}
/**
 *
 * @param collection
 * @param aggregateName
 * @param data
 */
export function aggregateQuery(collection: string, aggregateName: string, data: any) {
	return aggregate(getDBName(), collection, aggregateName, data)
}

/**
 *
 * @param collection
 * @param data
 */
export function putObject(collection: string, data: any) {
	return putCollectionObject(getDBName(), collection, data)
}

/**
 *
 * @param collection
 * @param filter
 */
export function querySize(collection: string, filter: FilterQuery) {
	return getDocumentSize(getDBName(), collection, filter)
}

/**
 * 获取文件对象。
 * @param collection
 * @param fileId
 */
export function getFileBinaryContent(collection: string, fileId: string) {
	return getFileBinary(getDBName(), collection, fileId)
}
